export default {
      id: "ic_authors_up-usage",
      viewBox: "0 0 9 15",
      url: "/" + "images/icons.3.109.2.svg#ic_authors_up-usage",
      toString: function () {
        return this.url;
      }
    }